/**
 * Columns for the site incidents list. Server-paged, so no client-side sorter.
 */
const SiteIncidentListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 70
  },
  {
    // The id people quote to each other when they talk about one incident.
    title: 'Incident ID',
    dataIndex: 'id',
    slot: 'incidentId',
    width: 110
  },
  {
    title: 'Website',
    dataIndex: 'site',
    slot: 'site',
    width: 240
  },
  {
    title: 'Category',
    dataIndex: 'categoryLabel',
    // The heading explains itself on hover: a first-time reader has no other
    // way to learn what the two categories mean.
    slotTitle: 'categoryTitle',
    width: 220
  },
  {
    // Says what happened to the WINDOW, not what the website is doing now:
    // Window Open, Manually Resolved, or Automatically Closed.
    title: 'Window State',
    dataIndex: 'windowState',
    slot: 'status',
    slotTitle: 'windowStateTitle',
    width: 170
  },
  {
    title: 'Severity',
    dataIndex: 'maxSeverity',
    slot: 'severity',
    width: 170
  },
  {
    title: 'Window Opened',
    dataIndex: 'openedAt',
    slot: 'openedAt',
    width: 130
  },
  {
    title: 'Last Alert in Window',
    dataIndex: 'lastAlertAt',
    slot: 'lastAlertAt',
    width: 140
  },
  {
    title: 'Window Closed',
    dataIndex: 'resolvedAt',
    slot: 'resolvedAt',
    width: 130
  },
  {
    title: 'Alerts',
    dataIndex: 'alertCount',
    width: 90
  },
  {
    title: 'Pages',
    dataIndex: 'pageCount',
    width: 90
  },
  // "Aggregated alerts" was the name of the whole section, used here for a
  // count of the groups inside ONE window. The detail page lists those groups,
  // so the number adds nothing to a list row. Left here, hidden, in case it is
  // wanted back.
  //
  // {
  //   title: 'Groups',
  //   dataIndex: 'eventCount',
  //   width: 100
  // },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { SiteIncidentListColumn };
